import { useAtomValue } from "jotai";
import { useAnnouncementToast as useBaseAnnouncementToast } from "../components";
import { AppState, UserType } from "../types";
import { roomAtom } from "../video-sdk/core/atoms";
import { useGetCurrentProviderQuery } from "./useGetCurrentProviderQuery";
import { useVideoPlatform } from "../hooks/useVideoPlatform";

export function useAnnouncementToast() {
  const { data } = useGetCurrentProviderQuery();
  const providerShortId = data?.currentProvider.shortId;
  const isInSession = !!useAtomValue(roomAtom);
  const videoPlatform = useVideoPlatform();

  useBaseAnnouncementToast({
    userId: providerShortId,
    userType: UserType.PROVIDER,
    appState: isInSession ? AppState.MEETING : AppState.WAITING,
    videoPlatform,
  });
}
